// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const AbcIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="AbcIcon" ref={forwardedRef} {...props}>
      <path d="M14.925 13.066c-.55-.635-.82-1.53-.82-2.705V9.293c0-1.223.27-2.157.81-2.811.54-.655 1.308-.982 2.327-.982a4.2 4.2 0 0 1 1.17.164 3.6 3.6 0 0 1 1.038.52L18.88 7.28a2.75 2.75 0 0 0-1.528-.462c-.64 0-1.109.202-1.418.616-.31.414-.47 1.05-.47 1.896v.982c0 .79.15 1.377.46 1.771.31.395.769.588 1.398.588.29 0 .56-.039.83-.126a2.5 2.5 0 0 0 .739-.365l.609 1.06a3.3 3.3 0 0 1-.999.567A3.6 3.6 0 0 1 17.272 14c-.999 0-1.778-.318-2.327-.953z" />
      <path d="M7.902 5.693h2.448c.799 0 1.418.192 1.848.558.43.375.649.885.649 1.54 0 .424-.1.79-.3 1.107a1.86 1.86 0 0 1-.68.64 3 3 0 0 1 .16.063 2 2 0 0 1 .94.76 2.17 2.17 0 0 1 .32 1.184 2.27 2.27 0 0 1-.32 1.204 2 2 0 0 1-.9.789c-.389.183-.848.27-1.378.27H7.902zm2.617 6.863c.47 0 .83-.096 1.07-.298s.359-.491.359-.857-.12-.684-.36-.886-.6-.308-1.069-.308H9.231v2.35zm0-3.465c.33 0 .59-.106.78-.308.19-.203.28-.472.28-.79 0-.317-.1-.587-.3-.78-.2-.182-.48-.279-.86-.279H9.231v2.157z" />
      <path d="M4.736 5.693H2.937L.5 13.817h1.409l.515-1.78H5.24l.494 1.77h1.439zM3.858 7.087l1.017 3.64H2.804z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const AbcIcon = /* @__PURE__ */ Object.assign(AbcIconComponent, {
  displayName: 'AbcIcon',
});
